import { ENVIRONMENT } from '@qsp-ui-library/../environments/environment';

declare let ENV_TYPE: 'dev' | 'pp' | 'staging' | 'prod';
declare let SERVER_URL_CONFIG: string;
declare let SERVER_URL_CONFIG_CN: string;

export const SERVER_URL = location.origin.includes('qima.cn') ? SERVER_URL_CONFIG_CN : SERVER_URL_CONFIG;

export const { INTERNAL_DOMAINS, LOGOUT_URL, LOGIN_URL } = ENVIRONMENT[ENV_TYPE];
